(() => {
  document.querySelectorAll('[data-product-quantity]').forEach((control) => {
    const input = control.querySelector('[data-product-quantity-input]');
    const decreaseButton = control.querySelector('[data-quantity-decrease]');
    const increaseButton = control.querySelector('[data-quantity-increase]');
    const productForm = control.closest('form');
    const variantSelect = productForm?.querySelector('select[name="id"]');
    if (!input || !decreaseButton || !increaseButton) return;

    const normaliseQuantity = (value) => {
      const minimum = Number(input.min) || 1;
      const maximum = input.max ? Number(input.max) : Infinity;
      return Math.min(Math.max(Number(value) || minimum, minimum), maximum);
    };

    const updateButtonStates = () => {
      const quantity = normaliseQuantity(input.value);
      decreaseButton.disabled = quantity <= (Number(input.min) || 1);
      increaseButton.disabled = Boolean(input.max) && quantity >= Number(input.max);
    };

    decreaseButton.addEventListener('click', () => {
      input.value = normaliseQuantity(Number(input.value) - 1);
      updateButtonStates();
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    increaseButton.addEventListener('click', () => {
      input.value = normaliseQuantity(Number(input.value) + 1);
      updateButtonStates();
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    input.addEventListener('change', () => {
      input.value = normaliseQuantity(input.value);
      updateButtonStates();
    });

    variantSelect?.addEventListener('change', () => {
      const maximum = variantSelect.selectedOptions[0]?.dataset.quantityMaximum;
      if (maximum) {
        input.max = maximum;
      } else {
        input.removeAttribute('max');
      }

      input.value = normaliseQuantity(input.value);
      updateButtonStates();
    });

    updateButtonStates();
  });
})();
